<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年04月14日 17:26:52 +0800
 * @最后修改时间: 2022-08-09 15:22:15
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Shift\ShiftList\components\viewProperty.vue
 -->
<template>
  <normalDialog
    width="800"
    maxWidth="800"
    @close="closePorpertyDialog"
    :title="$t('label_essweb_shift_form_dialog_viewPropertyLabel')"
    :dialog="show"
  >
    <template v-slot:content>
      <v-form ref="form" lazy-validation>
        <v-row dense>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-select
              :items="EventPropertyGroup"
              item-text="event_property_group_name"
              item-value="uuid"
              dense
              :menu-props="{
                offsetY: true,
                transition: 'slide-y-transition',
                rounded: true,
                contentClass: 'elevation-4',
              }"
              append-icon=""
              disabled
              :placeholder="
                $t('label_essweb_shift_form_dialog_eventPropertyGroupLabel')
              "
              v-model="Data.event_property_group_uuid"
              single-line
            >
              <template v-slot:no-data> <noContent /> </template>
            </v-select>
          </v-col>
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="12"
            cols="12"
            class="grey lighten-5 rounded-lg"
          >
            <PropertyList
              :items="desserts"
              :canEdit="false"
              :canView="false"
              :listdata="PropertyListData"
            />
          </v-col>
        </v-row>
      </v-form>
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "ViewPropertyGroup",
  props: ["group_uuid", "show"],
  computed: {
    ...mapGetters(["companyLang"]),
    EventPropertyGroup() {
      return this.$getSelectTrans(
        this.eventPropertyGroupData,
        "event_property_group_name"
      );
    },
  },
  data() {
    return {
      eventPropertyGroupData: [],
      RosterPropertyData: [],
      PropertyListData: null,
      Data: {
        event_property_group_uuid: "",
      },
      desserts: [],
      headers: [
        {
          text: "Type",
          value: "type",
          align: "left",
          sortable: false,
        },
        {
          text: "Name",
          value: "name",
          align: "left",
          sortable: false,
        },
        { text: "Value", value: "value", align: "left", sortable: false },
      ],
    };
  },
  watch: {
    group_uuid(val) {
      if (val) {
        this.Data.event_property_group_uuid = val;
        this.getPorpertyList(val);
      }
    },
  },
  mounted() {
    this.getPropertyType();
  },
  methods: {
    closePorpertyDialog: function () {
      this.$emit("close", false);
    },
    getPorpertyList: function (uuid) {
      const that = this;
      this.desserts = [];
      this.$Request({
        method: "POST",
        table: "ess_att_event_property",
        url: "/event-property/get-event-property-list/",
        data: {
          event_property_group_uuid: uuid,
        },
      }).then((res) => {
        res.data.forEach((item) => {
          item["changeList"] = [];
          if (item.property_master_code.indexOf("|") != -1) {
            item["p_property_master_code"] =
              item.property_master_code.substring(
                0,
                item.property_master_code.lastIndexOf("|")
              );
          }
        });
        that.PropertyListData = res.data;
        that.desserts = that.$translateDataToTree(
          res.data,
          "property_master_code",
          "p_property_master_code"
        );
      });
    },

    getPropertyType: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_event_property_group",
        url: "/event-property-group/get-event-property-group-list/",
      }).then((res) => {
        that.eventPropertyGroupData = res.data;
      });
    },
  },
};
</script>
<style>
/* .v-data-table-header {
  background: grey;
  background-color: grey;
} */
</style>
